import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { pluck } from 'rxjs/operators'
import { MB_PRODUCT_TAB_REFERENCES_NORMALIZER, MbProductTabReferencesAdapter } from '../connectors'

@Injectable({
  providedIn: 'root'
})
export class MbOccProductTabReferencesAdapter implements MbProductTabReferencesAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load (productCode: string, maxCount?: number) {
    return this.http.get(this.getEndpoint(productCode, maxCount)).pipe(
      pluck('references'),
      this.converter.pipeable(MB_PRODUCT_TAB_REFERENCES_NORMALIZER)
    )
  }

  protected getEndpoint (code: string, maxCount?: number) {
    return this.occEndpoints.buildUrl(
      'productTabReferences',
      {
        urlParams: { productCode: code },
        queryParams: { maxCount },
      }
    )
  }
}
